import React, {createContext, useCallback, useContext, useMemo} from "react";
import PropTypes from "prop-types";
import useGA from "Utils/Ga";
import {useSelector} from "react-redux";

const CartItemContext = createContext({
    item: null,
    SetFavoriteInGA: () => { throw new Error("Contexto não atribuido!") },
    SetRemoveFromCartInGA: () => { throw new Error("Contexto não atribuido!") },
})

export const useCartItem = () => useContext(CartItemContext)

const CartItemProvider = ({ item, children }) => {
    const Catalog = useSelector(({ Catalog: data }) => data)
    const { eventGaUnlimited } = useGA()

    const SetFavoriteInGA = useCallback(() => {
        eventGaUnlimited({
            event: "add_to_wishlist",
            currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
            value: parseFloat(item.price),
        }, {
            items: [
                {
                    item_id: item.sku,
                    item_name: item.name,
                    currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
                    item_brand: item.vendor.name,
                    price: parseFloat(item.price),
                    quantity: item.quantity
                }
            ]
        })
    }, [ Catalog, item ])

    const SetRemoveFromCartInGA = useCallback(() => {
        eventGaUnlimited({
            event: "remove_from_cart",
        }, {
            items: [
                {
                    item_id: item.sku,
                    item_name: item.name,
                    currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
                    item_brand: item.vendor.name,
                    price: parseFloat(item.price),
                    quantity: item.quantity
                }
            ]
        })
    }, [ Catalog, item ])

    const value = useMemo(() => ({
        item,
        SetFavoriteInGA,
        SetRemoveFromCartInGA
    }), [ item, SetFavoriteInGA, SetRemoveFromCartInGA ])

    return (<CartItemContext.Provider value={value}>
        { children }
    </CartItemContext.Provider>)
}

CartItemProvider.propTypes = {
    item: PropTypes.object,
}

export default CartItemProvider
